<div class="view-layers-bar">

  <app-view-layers-slider class="view-layers-bar__slider" [ngClass]="{
    'view-layers-bar__slider--large': isLarge(),
    'view-layers-bar__slider--small': !isLarge(),
    'view-layers-bar__slider--disabled': assetsLoading
  }"></app-view-layers-slider>

</div>